<soft-page>
  @if (auftrag$ | async; as order) {
    <div class="flex md:flex-row flex-col w-full justify-between gap-4 mt-4">
      <div class="w-full">
        <h6 class="soft-overline">Objekt Titel</h6>
        <div class="soft-card justify-between flex">
          <p class="soft-text">{{ order?.object?.name }}</p>
        </div>
      </div>
      <div class="w-full">
        <h6 class="soft-overline">Objekt Nummer</h6>
        <div class="soft-card justify-between flex">
          <p class="soft-text">{{ order?.object?.number }}</p>
        </div>
      </div>
    </div>
    <div class="flex md:flex-row flex-col w-full justify-between gap-4 mt-4">
      <div class="w-full">
        <h6 class="soft-overline">Auftrag Kopftext</h6>
        <div class="soft-card">
          <p class="soft-text">
            @if (!order.description || order.description.length === 0) {
              <span class="color-light italic"> -- Kein Kopftext hinterlegt -- </span>
            } @else {
              {{ order.description }}
            }
          </p>
        </div>
      </div>
      <div class="w-full">
        <h6 class="soft-overline">Auftrag Nummer</h6>
        <div class="soft-card justify-between flex">
          <p class="soft-text">{{ order?.number }}</p>
        </div>
      </div>
    </div>
    <div class="flex md:flex-row flex-col w-full justify-between gap-4 mt-4">
      @if (
        order.customer.name1 &&
        order.customer.name1.length > 0 &&
        order.customer.name2 &&
        order.customer.name2.length > 0
      ) {
        <div class="w-full">
          <h6 class="soft-overline">Kunden Name</h6>
          <div class="soft-card">
            <p class="soft-text">
              {{ order?.customer?.name1 }}
              {{ order?.customer?.name2 }}
            </p>
          </div>
        </div>
      } @else if (order.customer.kurzbez && order.customer.kurzbez.length > 0) {
        <div class="w-full">
          <h6 class="soft-overline">Kunden Kurzbezeichnung</h6>
          <div class="soft-card justify-between flex">
            {{ order.customer.kurzbez }}
          </div>
        </div>
      }
      <div class="w-full">
        <h6 class="soft-overline">Kunden nummer</h6>
        <div class="soft-card justify-between flex">
          <p class="soft-text">{{ order?.customer?.number }}</p>
        </div>
      </div>
    </div>
    @if (order?.customer) {
      <div class="mt-5">
        <h6 class="soft-overline">Kunden adresse</h6>
        <div class="soft-card justify-between flex">
          <div>
            <p class="soft-text">
              {{ order?.customer?.strasse }}{{ order?.customer?.strassenr }}
            </p>
            <p class="soft-text">{{ order?.customer?.plz }} {{ order?.customer?.ort }}</p>
          </div>
          @if (order?.customer) {
            <a
              target="_blank"
              class="soft-link flex"
              [attr.href]="getGoogleLink(order?.customer)"
              >{{ '#WORKSHOP.TASK_DETAILS.CUSTOMER.ADDRESS.GOOGLE_MAPS' | translate
              }}<soft-icon
                name="fa-regular fa-up-right-from-square"
                class="pl-2"
              ></soft-icon
            ></a>
          }
        </div>
      </div>
    }
    @if (
      (order.customer?.phones?.length || 0) > 0 ||
      (order.customer?.emails?.length || 0) > 0
    ) {
      <div class="mt-4">
        <h6 class="soft-overline">
          {{ '#WORKSHOP.TASK_DETAILS.CUSTOMER.CONTACTS.TITLE' | translate }}
        </h6>
        <div class="flex flex-col flex-nowrap justify-center soft-card">
          @for (
            element of order.customer?.phones || [];
            track element;
            let last = $last
          ) {
            <div
              class="flex flex-row flex-nowrap items-center justify-between pt-2 pb-2"
              [class.border-separator]="
                (order.customer?.emails?.length || 0) > 0 ? true : !last
              "
            >
              <span class="soft-text">{{ element?.type }}</span>
              <a class="soft-link" [href]="'tel:' + element?.number">{{
                element?.number
              }}</a>
            </div>
          }
          @for (
            element of order.customer?.emails || [];
            track element;
            let i = $index;
            let last = $last
          ) {
            <div
              class="flex flex-row flex-nowrap justify-between items-center pt-2 pb-1"
              [class.border-separator]="!last"
            >
              <span class="soft-text">{{ element?.type || 'Email ' + (i + 1) }}</span>
              <a class="soft-link" [href]="'mailto:' + element?.email">{{
                element?.email
              }}</a>
            </div>
          }
        </div>
      </div>
    }
    @if (order?.sellingType?.name) {
      <div class="mt-5">
        <h6 class="soft-overline">
          {{ '#WORKSHOP.TASK_DETAILS.SELLING_TYPE.HEADER' | translate }}
        </h6>
        <div class="soft-card">
          <p class="soft-text">{{ order?.sellingType?.name }}</p>
        </div>
      </div>
    }
    @if (order?.info && (order.info?.length || 0) > 0) {
      <div class="mt-4">
        <h6 class="soft-overline">
          {{ '#WORKSHOP.TASK_DETAILS.SHIPPING_INFO.HEADER' | translate }}
        </h6>
        @for (info of order?.info; track info; let i = $index) {
          <div
            class="flex flex-col"
            [ngClass]="[i < 1 ? 'shipping-info-condensed' : 'shipping-info']"
          >
            <p class="soft-text">{{ info }}</p>
          </div>
        }
      </div>
    }
    <div class="mt-4">
      <h6 class="soft-overline">
        {{ '#WORKSHOP.TASK_DETAILS.QUICK_ACTIONS.HEADER' | translate }}
      </h6>
      <div class="mt-2 flex w-full">
        <button
          class="soft-button accent mr-1 items-center flex w-1/2 justify-center hover:bg-hover rounded h-12"
          (click)="navigateToAddTaskItems(order.id)"
        >
          <soft-icon name="fa-regular fa-clipboard-list" class="mr-3"></soft-icon>
          <span>{{ '#WORKSHOP.TASK_DETAILS.QUICK_ACTIONS.ADD_ITEMS' | translate }}</span>
        </button>
        <button
          class="soft-button accent ml-1 items-center flex w-1/2 justify-center hover:bg-hover rounded h-12"
          (click)="navigateToManualWorkReport(order)"
        >
          <soft-icon name="fa-regular fa-user-clock" class="mr-3"></soft-icon>
          <span>{{
            '#WORKSHOP.TASK_DETAILS.QUICK_ACTIONS.WORK_REPORT' | translate
          }}</span>
        </button>
      </div>
      <p class="color-light mt-1 block text-sm">
        {{ '#WORKSHOP.TASK_DETAILS.QUICK_ACTIONS.DESCRIPTION' | translate }}
      </p>
    </div>
    @if (auftragArtikel$ | async; as items) {
      <div class="mt-8">
        @if (!(auftragArtikelLoading$ | async) && (items?.length || 0) > 0) {
          <h6 class="soft-overline condensed">
            {{ '#WORKSHOP.TASK_DETAILS.ITEMS.HEADER' | translate }}
          </h6>
          @for (item of items; track item; let i = $index) {
            <soft-auftrag-artikel-card
              (moreTap)="moreTapped(item, order, i)"
              [item]="item"
              [removingIndex]="processingArtikelIndex$ | async"
              [index]="i"
            >
            </soft-auftrag-artikel-card>
          }
        }
      </div>
    }
    @if (arbeitsberichte$ | async; as arbeitsberichte) {
      <div class="mt-8 mb-3">
        @if (!(arbeitsberichteLoading$ | async) && (arbeitsberichte?.length || 0) > 0) {
          <h6 class="soft-overline condensed">
            {{ '#WORKSHOP.TASK_DETAILS.REPORTS.HEADER' | translate }}
          </h6>
          <div class="order-item-list">
            @for (item of arbeitsberichte; track item; let i = $index) {
              <soft-arbeitsbericht-card
                (delete)="deleteArbeitsbericht(item)"
                [item]="item"
                [index]="i"
              >
              </soft-arbeitsbericht-card>
            }
          </div>
        }
      </div>
    }
    <div class="mt-8 mb-3">
      <h6 class="soft-overline condensed mb-1">
        {{ '#WORKSHOP.TASK_DETAILS.PICTURES.HEADER' | translate }}
      </h6>
      <soft-archive-list [archiveKey]="order?.archiveKey"></soft-archive-list>
    </div>
    <div class="mt-5 mb-3">
      <div class="flex flex-row justify-between flex-nowrap center-v">
        <h6 class="soft-overline condensed">
          {{ '#WORKSHOP.TASK_DETAILS.SIGN.HEADER' | translate }}
        </h6>
        @if (!order?.signature) {
          <span class="sign-status text-sm color-light uppercase text-danger-600">{{
            '#WORKSHOP.TASK_DETAILS.SIGN.STATUS_ERROR' | translate
          }}</span>
        }
      </div>
      <soft-signature-input
        [value]="order?.signature ? (order?.signature | getSignature | async) : undefined"
        (valueChange)="signTask(order, $event)"
      ></soft-signature-input>
    </div>
  } @else {
    <div class="loading flex items-center justify-center text-right">
      <soft-loading-spinner class="spin"></soft-loading-spinner>
    </div>
  }
</soft-page>
